import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Play, Square, CheckCircle } from 'lucide-react';

/**
 * ContractorActionButtons
 *
 * Action buttons for job instances based on their current status.
 * Handles Clock In, Continue Work, Clock Out & Submit, and Job Completed states.
 */
const ContractorActionButtons = ({
  instance,
  onClockIn,
  onClockOut,
  compact = false
}) => {
  const navigate = useNavigate();
  const status = instance?.status;

  // Assigned - Ready to start
  if (status === 'assigned') {
    return (
      <button
        onClick={(e) => {
          e.stopPropagation();
          onClockIn?.(instance.id);
        }}
        className={`flex items-center space-x-2 bg-green-500 hover:bg-green-600 text-white rounded-lg transition-colors touch-target-sm ${
          compact ? 'px-3 py-2 sm:py-1.5 text-sm' : 'px-4 py-2.5 sm:py-2'
        }`}
      >
        <Play size={compact ? 14 : 16} />
        <span>Clock In</span>
      </button>
    );
  }

  // In Progress - Working on it
  // Always redirect to job execution page to ensure mandatory fields are completed
  if (status === 'in_progress') {
    return (
      <button
        onClick={(e) => {
          e.stopPropagation();
          navigate(`/contractor-job-execution/${instance.id}`);
        }}
        className={`flex items-center space-x-2 bg-orange-500 hover:bg-orange-600 text-white rounded-lg transition-colors touch-target-sm ${
          compact ? 'px-3 py-2 sm:py-1.5 text-sm' : 'px-4 py-2.5 sm:py-2'
        }`}
      >
        <Square size={compact ? 14 : 16} />
        <span>{compact ? 'Continue' : 'Continue & Submit'}</span>
      </button>
    );
  }

  // Submitted or Approved - Completed
  if (status === 'submitted' || status === 'approved') {
    return (
      <div className="flex items-center space-x-2 text-green-500">
        <CheckCircle size={compact ? 16 : 20} />
        <span className={`font-medium ${compact ? 'text-sm' : ''}`}>
          {status === 'approved' ? 'Approved' : 'Submitted'}
        </span>
      </div>
    );
  }

  // Default - No actions available
  return null;
};

export default ContractorActionButtons;
